import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './index.css';

import MainLayout from './routes/main';

const Home = lazy(() => import('./routes/Inicio/inicio'));
const Turismo = lazy(() => import('./pages/mapaTuristicos/MapaTuristico'));
const SobreNosotros = lazy(() => import('./routes/SobreNosotros/sobreNosotros'));
const Contact = lazy(() => import('./routes/Contactanos/contactanos'));
const Reserva = lazy(() => import('./pages/Booking/Booking'));

function RouteSkeleton() {
  return (
    <div className="min-h-[60vh] w-full bg-white">
      <div className="mx-auto max-w-6xl px-6 py-16">
        <div className="h-6 w-40 rounded-full bg-black/5" />
        <div className="mt-6 h-10 w-64 rounded-full bg-black/5" />
        <div className="mt-8 h-64 w-full rounded-3xl bg-black/[0.03]" />
      </div>
    </div>
  );
}

const withSuspense = (node: React.ReactNode) => (
  <Suspense fallback={<RouteSkeleton />}>{node}</Suspense>
);



const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />, 
    children: [
      {
        index: true,
        element: withSuspense(<Home />),
        
      },
      {
        path: 'turismo',
        element: withSuspense(<Turismo />),
      },
      {
        path: 'sobre-nosotros',
        element: withSuspense(<SobreNosotros />),
      },      
      {
        path: 'contactanos',
        element: withSuspense(<Contact />),
      },
      {
        path:'reserva',
        element: withSuspense(<Reserva />),
      }
    ],
  },
]);


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    
      <RouterProvider router={router} />
  </React.StrictMode>,
)
